import clsx from 'clsx'
import Logo from '../ui/Logo'

export default function NotFoundScreen() {
    return (
        <div className='z-200 absolute inset-0 flex flex-col justify-center items-center gap-6  p-6 w-svw h-svh text-center'>
            <img src='/images/KeyvizDesktop.png' className='absolute inset-0 w-full h-full object-cover' />
            <div className='bg-black/50 absolute inset-0' />
            <div className='absolute inset-0 flex flex-col justify-between items-center px-4 py-6 bg-vignette'>
                <Logo variant='stacked' />
                <div
                    className={clsx(
                        'flex bg-white-gradient border-white-stroke w-full pattern-background items-center justify-center drop-shadow-2-white-stroke',
                        'gap-3 p-4 pt-8 border rounded-3xl max-w-90',
                        'stele:rounded-[96px] stele:gap-12 stele:p-16'
                    )}>
                    <img src='/images/404.png' className='absolute -top-24' />
                    <div className='flex flex-col items-center justify-center text-left gap-2'>
                        <p className='font-grandstander font-bold text-[16px] text-white-stroke-even-darker italic leading-[100%] tracking-[0%] uppercase'>Seite nicht gefunden</p>
                        <p className='font-nunito text-[12px] text-white-stroke-even-darker leading-[135%] tracking-[0%] whitespace-nowrap'>Sieht so aus, als wärst du falsch abgebogen</p>
                    </div>

                </div>
            </div>
        </div>
    )
}
